<template>
  <div class="home">
    <div class="home__wrapper">
      <div class="col-map col">
        <div id="map">
          <GmapMap
            ref="gmapRef"
            :center="{lat:22.174528, lng:113.550585}"
            :zoom="mapZoom"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUi: false,
              scrollwheel: false,
              maxZoom: 18,
              minZoom: 8,
              styles: content.gmapstyle
            }"
          >
            <GmapMarker
              :key="index"
              v-for="(spot, index) in currentSpots"
              :position="google && new google.maps.LatLng(spot.position.lat, spot.position.lng)"
              :clickable="true"
              :icon="{ 
                url: getIcon(spot.slug), 
                size: {width: 48, height: 60},
                scaledSize: {width: 48, height: 60}
              }"
              @click="markerClick(spot.slug)"
            />
          </GmapMap>
        </div>
        <div class="quicklink">
          <div id="logo">
            <img src="@/assets/logo.png" />
          </div>
          <a class="btn-back" target="_blank" href="https://multimedia.scmp.com/native/infographics/article/MGTO/uncover-art-macao/">Back to Home</a>
        </div>
        
        <div id="mobile-nav">
          <div class="selectedCategory" :class="currentCategory.slug" @click="isShowingNav = !isShowingNav">
            <span v-if="currentCategory.slug == 'foodie'">Tasty pursuits</span>
            <span v-if="currentCategory.slug == 'instagrammable'">Insta picks</span>
            <span v-if="currentCategory.slug == 'off'">Off the beaten path </span>
            <span v-if="currentCategory.slug == 'cultural'">Cultural explorer</span>
          </div>
          <div class="selectCategories" v-if="isShowingNav">
            <a class="select__item" 
              v-if="currentCategory != category"
              v-for="category in content.categories"
              @click="mbSetCategory(category.slug)" v-text="category.name" >
            </a>
          </div>
        </div>
      </div>
      <div class="col-content col">
        <div class="category-intro" :class="currentCategory.slug">
          <p v-text="currentCategory.info"></p>
        </div>

        <div class="spots" id="spots">
          <div class="wrapper">
            <div class="spot" v-for="spot in currentSpots" v-bind:id="spot.slug">
              <h2 class="spot__name" v-text="spot.name"></h2>
              <div class="image-wrapper">
                <img class="spot__image" :src="require('@/assets/spots/' + spot.photos.url)" />
              </div>
              <div class="spot__info" v-html="spot.info"></div>
              <a class="btn-link" @click="viewGoogleMap(spot.position.lat, spot.position.lng)" v-bind:href="spot.article" target="_blank">Open in Google Maps</a>
              <a class="btn-link" v-show="spot.article!='none' && spot.article!=''" v-bind:href="spot.article" target="_blank">READ MORE ON SCMP.COM</a>
            </div>
            <div class="spacer"></div>
          </div>
          
        </div>
      </div>
    </div>

    <!-- navigation bar START -->
    <div class="nav-bar">
      <div class="nav-container">
        <div class="wrapper">
          <a class="btn-category" 
          :class="{
            'active': currentCategory.slug == category.slug,
            'foodie':         category.slug == 'foodie',
            'instagrammable': category.slug == 'instagrammable',
            'off':            category.slug == 'off',
            'cultural':       category.slug == 'cultural'
          }"
          v-for="category in content.categories" 
          v-text="category.name"
          @click="setCategory(category.slug)" ></a>
        </div>
      </div>
    </div>
    <!-- navigation bar END -->

    <!-- mobile content START -->
    <div class="card">
      <div class="wrapper" >
        <div class="spot">
          <h2 class="spot__name" v-text="currentSpot.name"></h2>
          <div class="spot__info" v-html="currentSpot.info"></div>
        </div>
      </div>
    </div>
    <div class="popupCard" v-if="isShowingPopup == true">
      <div class="wrapper">
        <div class="spot">
          <h2 class="spot__name" v-text="currentSpot.name"></h2>
          <div class="image-wrapper">
            <img class="spot__image" :src="require('@/assets/spots/' + currentSpot.photos.url)" />
          </div>
          <div class="spot__info" v-html="currentSpot.info"></div>
          <a class="btn-link" @click="viewGoogleMap(currentSpot.position.lat, currentSpot.position.lng)" v-bind:href="currentSpot.article" target="_blank">Open in Google Maps</a>
          <a class="btn-link" v-show="currentSpot.article != 'none'" v-bind:href="currentSpot.article" target="_blank">READ MORE ON SCMP.COM</a>
          <br />
          <a class="btn-link btn-back" target="_blank" href="https://multimedia.scmp.com/native/infographics/article/MGTO/uncover-art-macao/">Back to Home</a>
        </div>
      </div>
    </div>
    <div class="card__nav">
      <a class="card-prev card-dir" @click="prevSpot"></a>
      <a class="card-next card-dir" @click="nextSpot"></a>
      <a class="btn-more" @click="isShowingPopup = !isShowingPopup">
        <span v-if="isShowingPopup == false">More info</span>
        <span v-if="isShowingPopup == true">Less info</span>
      </a>
    </div>
    <!-- mobile content END -->

    <div class="overlay" id="overlay">
      <div class="bg"></div>
      <div class="overlay__block">
        <img src="@/assets/logo.png" class="overlay__logo"/>
        <div class="intro">
          Follow us on a journey in Macao with these interactive maps.<br /><br />A city of contradictions, Macao is both a historical port of Unesco fame and an entertainment hub with state-of -the-art facilities. Different cultures from all corners of the globe have converged here for centuries. Go explore!
        </div>
        <div style='text-align: center'>
          <div>To begin, choose one of the four categories</div>
          <br />
          <img src="@/assets/intro_01.jpg" class="cap"/>
          <br />
          <div>and explore the map</div>
          <br />
          <img src="@/assets/intro_02.jpg" class="cap"/>
        </div>
        <a class="btn-close" @click="closeOverlay"></a>
      </div>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '../components/HelloWorld.vue'
import {data} from "../scripts/data.js";
import IScroll from '../../node_modules/iscroll/build/iscroll-probe.js';
import imagesLoaded from 'imagesloaded';
import {gmapApi} from 'vue2-google-maps'
import jquery from 'jquery';

export default {
  name: 'home',
  components: {
    //HelloWorld
  },
  data: function () {
    return {
      content: data,
      currentCategory: {},
      isShowingPopup: false,
      mapZoom: 13,
      /* spots */
      currentSpots: [],
      currentSpot: '',
      currentIndex: '',
      /* iscroll */
      spotsScroll: '',
      initedIscroll: false,
      isShowingNav: false
    }
  },
  computed: {
    google: gmapApi
  },
  watch: {
    currentSpots: function(newVal, oldVal){
      let vm = this;
      let map = this.$refs.gmapRef;
      /*map.panTo({
        lat: 22.174528, 
        lng: 113.550585
      });*/

      if(google.maps){
        console.log(map)
        let bounds = new google.maps.LatLngBounds();
        for(var i=0; i<newVal.length; i++){
          let item = newVal[i];
          var pos = new google.maps.LatLng(item.position.lat, item.position.lng);
          bounds.extend(pos);
        }
        //console.log(bounds);
        map.fitBounds(bounds);
      }
      
    },
    currentSpot: function(newVal, oldVal){
      console.log('currentSpot:', newVal)
      let idx = this.currentSpots.indexOf(newVal)
      this.currentIndex = idx;
      //this.panToSpot(newVal);
      //this.scrollToSpot(newVal);
    }
  },
  methods: { 
    showOverlay: function(){
      jquery('#overlay').fadeIn();
    },
    closeOverlay: function(){
      jquery('#overlay').hide();
    },
    mbSetCategory: function(slug){
      this.setCategory(slug);
      this.isShowingNav = false;
    },
    getIcon: function(slug){
      let vm = this;
      let img = require('@/assets/pin-red.png');

      switch (this.currentCategory.slug) {
        case 'foodie':
          img = require('@/assets/pin-red.png');
          if( slug == vm.currentSpot.slug ){
            img = require('@/assets/pin-red-solid.png');
          }
          break;
        case 'instagrammable':
          img = require('@/assets/pin-green.png');
          if( slug == vm.currentSpot.slug ){
            img = require('@/assets/pin-green-solid.png');
          }
          break;
        case 'off':
          img = require('@/assets/pin-yellow.png');
          if( slug == vm.currentSpot.slug ){
            img = require('@/assets/pin-yellow-solid.png');
          }
          break;
        case 'cultural':
          img = require('@/assets/pin-blue.png');
          if( slug == vm.currentSpot.slug ){
            img = require('@/assets/pin-blue-solid.png');
          }
          break;
      }

      return img;
    },
    viewGoogleMap: function(lat, lng){
      //let url = "https://www.google.com/maps/@"+lat+","+lng+",18z";
      let url = 'https://www.google.com/maps/search/?api=1&query='+lat+','+lng

      window.open(url)
    },
    prevSpot: function(){
      let vm = this;
      vm.currentIndex--;
      if(vm.currentIndex < 0){
        vm.currentIndex = vm.currentSpots.length - 1
      }
      vm.currentSpot = vm.currentSpots[vm.currentIndex];
      vm.panToSpot( vm.currentSpot.slug )
    },
    nextSpot: function(){
      let vm = this;
      vm.currentIndex++;
      if(vm.currentIndex >= vm.currentSpots.length){
        vm.currentIndex = 0
      }
      vm.currentSpot = vm.currentSpots[vm.currentIndex];
      vm.panToSpot( vm.currentSpot.slug )
    },
    markerClick: function(slug){
      this.panToSpot(slug)
      this.scrollToSpot(slug)
      this.currentSpot = this.currentSpots.filter(spot=>spot.slug == slug)[0];
      if(window.innerWidth < 768){
        this.currentSpot = this.currentSpots.filter(spot=>spot.slug==slug)[0];
      }
    },
    panToSpot: function(slug){
      let vm = this;
      let spot = this.currentSpots.filter(spot=>spot.slug == slug)[0];
      let map = vm.$refs.gmapRef;
      map.panTo({
        lat: spot.position.lat, 
        lng: spot.position.lng
      })

      if(google.maps){
        let pos = new google.maps.LatLng(spot.position.lat, spot.position.lng);
        let bounds = new google.maps.LatLngBounds(pos);
        map.fitBounds(bounds);
      }
    },
    scrollToSpot: function(slug){
      let vm = this;
      let elm = document.getElementById(slug);
      //let offsetTop = elm.offsetTop
      let offsetTop = jquery('#'+slug).offset().top - (80 + 60)
      //vm.spotsScroll.scrollTo(0, -offsetTop, 400)
      vm.$jq('html, body').animate({
        scrollTop: offsetTop
      }, 200);

    },
    setCategory: function(slug){
      let vm = this;
      let list = vm.content.spots.filter(spot=>spot.category == slug);
      let category = vm.content.categories.filter(category=>category.slug == slug)[0];
      vm.currentCategory = category;
      vm.currentSpots = list;
      vm.currentSpot = list[0];
      /*setTimeout(function(){
        imagesLoaded( '#spots', function( instance ) {
          vm.updateIsroll();
        });
      },0)*/
      
    },
    updateIsroll: function(){
      let vm = this;
      if( vm.initedIscroll == false ){
        console.log( 'initedIscroll == false' )
        vm.spotsScroll = new IScroll( document.getElementById('spots'), {
          mouseWheel: true,
          scrollX: false,
          scrollY: true,
          probeType: 3
        } );
        vm.spotsScroll.on('scrollEnd', function(){
          vm.getCurrentSpot(this.y*-1);
        });
        vm.initedIscroll = true;
      }else{
        console.log( 'initedIscroll == true' )
        vm.spotsScroll.refresh()
      }
    },
    updateScroll: function(e){
      let vm = this;
      let posY = document.documentElement.scrollTop;
      let halfHeight = window.innerHeight/2;
      for(var i=0; i<vm.currentSpots.length; i++){
        let id = vm.currentSpots[i].slug;
        let elm = document.getElementById(id);
        //let offset = elm.offsetTop
        let offset = jquery("#"+id).offset().top
        let height = elm.clientHeight
        if(posY + halfHeight >= offset && posY + halfHeight < offset+height){
          vm.currentSpot = vm.currentSpots[i];
          vm.panToSpot(id);
        }
      }
    },
    getCurrentSpot: function(posY){
      let vm = this;
      for(var i=0; i<vm.currentSpots.length; i++){
        let id = vm.currentSpots[i].slug;
        let elm = document.getElementById(id);
        //let offset = elm.offsetTop
        let offset = jquery("#"+id).offset().top;
        let height = elm.clientHeight
        if(posY >= offset && posY < offset+height){
          vm.currentSpot = id;
          vm.panToSpot(id);
        }
      }
    },
    bindEvt: function(){
      let vm = this;
      document.addEventListener('mousewheel', vm.updateScroll)
    },
    unbindEvt: function(){
      document.removeEventListener('mousewheel')
    }
  },
  mounted: function(){
    this.setCategory('foodie')
    this.bindEvt();
    let vm = this;
    setTimeout(function(){
      vm.showOverlay();
    },1000)
  },
  beforeDestroy: function(){
    this.unbindEvt();
  }
}
</script>
